import { createFileRoute, Navigate } from "@tanstack/react-router";
import { SignIn } from "@clerk/clerk-react";

/**
 * Route configuration for the sign-in page.
 * Accepts optional redirect search parameter to return users to their intended destination.
 * Uses catch-all route ($) to handle Clerk's authentication flow paths like /signin/sso-callback
 */
export const Route = createFileRoute("/signin/$")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: (search.redirect as string) || "/document-upload",
  }),
  component: SignInPage,
});

/**
 * Sign-in page component.
 * Renders Clerk's authentication UI for user login.
 * Redirects authenticated users to their intended destination.
 *
 * @returns Centered sign-in form
 */
function SignInPage() {
  const { auth } = Route.useRouteContext();
  const { redirect } = Route.useSearch();

  // If user is already authenticated, redirect immediately
  if (auth.isAuthenticated) {
    return <Navigate to={redirect} />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#fafafa]">
      <SignIn
        routing="path"
        path="/signin"
        signUpUrl="/signup"
        fallbackRedirectUrl={redirect}
      />
    </div>
  );
}
